var _path, _g, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 743,
    height: 721,
    viewBox: "0 0 743 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_1768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 744,
    height: 722
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M743.002 -0.000228883H0V720.327H743.002V-0.000228883Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.224 682.813C186.224 682.813 39.7754 571.347 5.33573 397.535C-29.2832 223.539 112.636 188.558 195.827 129.654C279.023 70.7491 309.65 4.41359 430.366 0.245083C550.891 -3.74256 613.427 41.0248 656.926 127.66C700.425 214.477 723.807 303.467 737.396 390.464C750.991 477.462 744.283 546.879 666.892 581.498C589.502 616.117 553.612 600.893 516.821 640.764C480.024 680.82 312.192 771.261 186.224 682.813Z",
    fill: "#DFFF02",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.675 647.618C206.675 647.618 76.3884 548.427 45.7496 393.757C14.9513 238.921 141.208 207.793 215.217 155.375C289.232 102.958 316.479 43.9274 423.872 40.218C531.095 36.6695 586.729 76.5068 625.428 153.602C664.126 230.857 684.927 310.048 697.017 387.464C709.111 464.881 703.144 526.654 634.294 557.461C565.445 588.267 533.516 574.72 500.785 610.2C468.049 645.845 318.74 726.326 206.675 647.618Z",
    fill: "#DFFF02",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.621 610.837C227.621 610.837 113.891 524.18 87.146 389.054C60.2615 253.785 170.473 226.59 235.078 180.796C299.686 135.002 323.471 83.4312 417.216 80.1905C510.814 77.0904 559.378 111.894 593.159 179.246C626.939 246.74 645.097 315.924 655.65 383.557C666.207 451.191 660.998 505.158 600.898 532.072C540.798 558.985 512.927 547.15 484.356 578.147C455.78 609.287 325.445 679.599 227.621 610.837Z",
    fill: "#DFFF02",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.134 680.514H726.919",
    stroke: "#BBBBBB",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4498 680.514H687.897",
    stroke: "#BBBBBB",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8648 680.514H34.0125",
    stroke: "#BBBBBB",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.021 303.55C121.021 303.55 103.182 293.585 101.932 316.232C100.682 339.061 97.2915 560.283 97.2915 560.283",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5459 318.241C92.5459 318.241 106.868 424.175 100.324 558.174",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.51 307.79C106.51 307.79 99.6227 312.144 95.6361 307.064C91.6495 301.983 98.3571 292.729 92.5565 288.737C86.7612 284.745 76.7947 290.914 76.7947 290.914C76.7947 290.914 84.5833 293.273 84.2247 297.447C84.0402 301.62 80.2382 303.253 79.695 301.439C79.1519 299.624 75.5291 290.37 69.1854 294.181C62.8469 297.991 61.94 303.979 61.94 303.979C61.94 303.979 76.6155 302.346 77.3379 307.971C78.2449 313.415 71.358 307.064 65.3834 306.701C59.4035 306.338 53.9668 307.245 54.3307 310.874C54.6945 314.503 53.7875 320.492 53.7875 320.492C53.7875 320.492 58.8604 315.955 65.5627 316.318C72.265 316.681 71.9064 320.854 65.9266 320.673C59.9467 320.492 54.6945 326.116 54.6945 326.116C54.6945 326.116 60.126 335.552 67.1922 340.27C74.2583 344.988 76.6155 343.173 77.5225 339.726C78.4242 336.097 76.4309 326.842 80.602 327.205C84.7679 327.387 73.5359 343.173 78.9673 344.081C84.4041 344.988 88.7545 343.536 90.0201 339.907L91.4702 336.278C91.4702 336.278 89.6562 327.024 90.3839 323.395C91.2909 319.766 92.1927 323.576 93.0997 327.75C94.0067 332.105 94.7291 342.448 96.5431 341.903C98.3571 341.359 104.332 333.919 105.603 330.834C107.053 327.931 97.8087 318.858 97.9932 317.044C98.1725 315.229 105.239 318.677 106.325 320.492C107.411 322.306 108.498 324.846 108.498 324.846C108.498 324.846 112.848 322.125 112.848 313.596C112.669 305.249 106.325 307.79 106.51 307.79Z",
    fill: "#86C25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9799 328.26C76.42 322.574 82.9958 315.054 88.3271 311.386",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7067 335.115C66.7067 335.115 67.8247 333.39 69.8707 330.897",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.491 312.44C91.491 312.44 98.1406 322.012 99.4009 331.951",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1084 318.266C84.1084 318.266 85.6271 317.18 85.0207 329.315",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8545 307.167C88.8545 307.167 92.2136 303.589 90.4523 296.62",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5812 312.968L80.9446 307.694",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.781 317.713C77.781 317.713 69.3438 311.219 64.0705 310.858",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.156 289.899C131.156 289.899 130.792 299.928 123.204 300.475C115.431 301.022 110.733 287.893 102.781 290.993C94.8288 294.093 94.1063 308.498 94.1063 308.498C94.1063 308.498 101.7 302.298 105.676 305.398C109.652 308.498 108.745 313.422 106.578 312.692C104.41 311.963 92.6615 309.228 92.2977 318.163C91.9391 327.098 97.1807 332.203 97.1807 332.203C97.1807 332.203 105.491 316.339 111.64 319.257C117.783 322.175 106.578 324.727 102.238 330.38C97.7238 336.215 95.0081 342.415 98.8048 344.421C102.781 346.609 108.022 351.532 108.022 351.532C108.022 351.532 106.936 343.327 111.819 336.763C116.697 330.38 120.673 333.48 116.338 339.315C111.819 345.15 114.166 354.268 114.166 354.268C114.166 354.268 127.36 355.179 136.577 351.35C145.974 347.521 145.974 343.874 142.905 340.592C139.831 337.309 129.532 332.933 132.601 328.739C135.675 324.727 143.807 346.791 148.326 341.868C152.845 337.127 154.29 331.657 151.759 327.827L149.228 323.998C149.228 323.998 138.745 319.621 135.855 316.339C132.78 313.057 137.12 314.516 142.183 316.522C147.06 318.528 157.902 324.909 158.625 322.722C159.347 320.533 155.914 309.41 153.926 305.945C151.938 302.481 136.757 305.581 134.953 304.304C133.144 303.028 141.455 298.287 143.986 298.469C146.517 298.651 149.771 299.199 149.771 299.199C149.771 299.199 149.95 292.816 141.455 287.163C132.78 281.693 131.156 289.899 131.156 289.899Z",
    fill: "#86C25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35 338.806C124.818 330.512 121.744 318.792 122.108 310.858",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.513 348.826C130.513 348.826 129.796 346.651 128.931 343.025",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.767 308.75C125.767 308.75 139.499 308.561 150.024 314.023",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.767 320.213C125.767 320.213 125.952 317.441 137.896 326.678",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.385 307.694C118.385 307.694 117.652 301.718 109.42 299.257",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.494 316.659L113.639 316.132",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.548 326.151C121.548 326.151 109.151 330.349 105.201 335.643",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2504 356.208C48.2504 356.208 91.3066 391.45 86.9667 557.12",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5799 349.422C96.5799 349.422 95.3143 360.821 86.2812 360.64C77.2481 360.46 73.0927 345.079 63.5165 347.974C53.9403 350.869 51.9523 367.155 51.9523 367.155C51.9523 367.155 61.1646 360.64 65.5045 364.803C69.8391 368.783 68.3943 374.212 65.8631 373.126C63.3372 372.041 50.1435 367.879 48.6986 378.193C47.4331 388.507 53.0385 394.84 53.0385 394.84C53.0385 394.84 64.239 377.469 70.9254 381.451C77.6067 385.248 64.5975 387.057 58.9973 393.39C53.3971 399.723 49.4211 406.42 53.761 409.136C58.0956 411.852 63.6958 418.185 63.6958 418.185C63.6958 418.185 63.3372 408.593 69.4806 401.717C75.8032 394.84 80.1378 398.821 74.3583 405.155C68.7529 411.488 70.3823 422.166 70.3823 422.166C70.3823 422.166 85.3795 424.518 96.5799 420.895C107.78 417.278 108.144 413.117 104.891 409.136C101.637 405.155 90.0779 399.001 94.0487 394.661C98.0247 390.316 105.254 416.371 110.855 411.309C116.634 406.241 118.622 400.087 116.091 395.563L113.565 390.859C113.565 390.859 102.001 384.89 98.7472 380.724C95.4936 376.745 100.377 378.915 105.977 381.631C111.398 384.346 123.141 392.852 124.222 390.316C125.309 387.785 122.234 374.755 120.246 370.774C118.264 366.612 100.377 368.783 98.5679 366.974C96.7592 365.345 106.699 360.64 109.589 361.002C112.658 361.545 116.275 362.45 116.275 362.45C116.275 362.45 117.177 355.212 107.78 347.793C99.111 340.374 96.5799 349.422 96.5799 349.422Z",
    fill: "#86C25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7998 405.25C85.6377 395.547 83.3017 381.715 84.3827 372.555",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4365 417.378C90.4365 417.378 89.7351 414.673 88.8545 410.523",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3272 370.446C88.3272 370.446 104.658 371.547 116.275 378.883",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7998 383.492C87.7998 383.492 88.3482 380.323 100.983 392.067",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8898 368.337C79.8898 368.337 79.5259 361.306 70.3979 357.79",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4719 378.883L73.562 377.829",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9995 389.957C81.9995 389.957 67.0604 393.606 61.9611 399.449",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5799 461.215C96.5799 461.215 95.3143 472.616 86.2812 472.436C77.2481 472.252 73.0927 456.87 63.5165 459.765C53.9403 462.665 51.9523 478.949 51.9523 478.949C51.9523 478.949 61.1646 472.436 65.5045 476.597C69.8391 480.578 68.3943 486.004 65.8631 484.918C63.3372 483.832 50.1435 479.671 48.6986 489.986C47.4331 500.3 53.0385 506.633 53.0385 506.633C53.0385 506.633 64.239 489.263 70.9254 493.245C77.6067 497.041 64.5975 498.85 58.9973 505.183C53.3971 511.516 49.4211 518.214 53.761 520.929C58.0956 523.645 63.6958 529.978 63.6958 529.978C63.6958 529.978 63.3372 520.386 69.4806 513.51C75.8032 506.633 80.1378 510.615 74.3583 516.948C68.7529 523.281 70.3823 533.959 70.3823 533.959C70.3823 533.959 85.3795 536.311 96.5799 532.689C107.78 529.071 108.144 524.911 104.891 520.929C101.637 516.948 90.0779 510.794 94.0487 506.454C98.0247 502.109 105.254 528.164 110.855 523.102C116.634 518.034 118.622 511.88 116.091 507.356L113.565 502.652C113.565 502.652 102.001 496.683 98.7472 492.517C95.4936 488.536 100.377 490.708 105.977 493.424C111.398 496.14 123.141 504.645 124.222 502.109C125.309 499.578 122.234 486.548 120.246 482.566C118.264 478.406 100.377 480.578 98.5679 478.77C96.7592 477.14 106.699 472.436 109.589 472.795C112.658 473.338 116.275 474.245 116.275 474.245C116.275 474.245 117.177 467.005 107.78 459.585C99.111 452.166 96.5799 461.215 96.5799 461.215Z",
    fill: "#86C25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7998 517.043C85.6377 507.187 83.3017 493.128 84.3827 483.821",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4365 528.644C90.4365 528.644 89.7351 525.939 88.8545 521.789",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3272 482.239C88.3272 482.239 104.658 483.341 116.275 490.676",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7998 495.285C87.7998 495.285 88.3482 492.116 100.983 503.859",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8898 480.13C79.8898 480.13 79.5259 472.747 70.3979 469.056",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4719 490.677L73.562 489.095",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9995 501.75C81.9995 501.75 67.0604 505.399 61.9611 511.242",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5429 436.104C63.5429 436.104 88.786 528.802 91.4912 557.647L86.2601 387.848",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 422.309C91.491 416.339 91.491 557.647 91.491 557.647",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7839 557.119C95.7839 557.119 76.3677 342.498 132.623 342.498",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.236 417.963C107.717 412.901 97.9612 412.901 92.361 425.926C86.5815 439.13 91.8231 436.779 91.8231 436.779C91.8231 436.779 102.66 433.34 109.525 430.988C116.391 428.637 125.419 423.031 125.962 426.469C126.505 429.907 121.448 433.34 115.126 434.427C108.803 435.513 92.361 440.217 93.9904 443.655C95.6146 447.088 99.7699 457.402 99.7699 457.402C99.7699 457.402 107.717 450.526 115.126 446.007C122.529 441.482 127.048 443.112 123.072 448.359C119.096 453.421 107.717 459.211 109.884 466.082C112.236 472.958 125.783 481.459 125.783 481.459C125.783 481.459 127.407 467.168 131.562 462.649C135.538 458.125 135.538 463.192 134.452 471.15C133.371 479.107 133.371 481.459 133.371 481.459L149.265 487.249C149.265 487.249 155.049 478.748 157.76 475.853L160.65 472.958C160.65 472.958 148.184 462.106 147.461 455.23C146.739 448.359 155.951 455.23 158.841 456.316C161.731 457.402 166.25 465.539 166.25 465.539C166.25 465.539 169.14 452.335 169.683 447.815L170.221 443.291C170.221 443.291 158.298 438.767 153.784 438.767C149.265 438.767 146.918 442.205 146.918 437.685C146.918 433.161 151.437 430.266 156.674 430.809C161.731 431.352 170.405 434.247 170.405 434.247C170.405 434.247 173.833 431.352 172.752 422.852C171.666 414.346 168.776 414.346 161.91 416.519C155.049 418.87 150.53 423.933 145.473 423.933C140.416 423.933 143.127 417.605 146.56 415.975C149.987 414.346 158.482 410.913 160.286 410.185C161.91 409.642 151.253 401.685 145.473 400.419C139.694 399.333 132.464 403.314 133.007 408.92C133.914 420.858 116.75 423.031 112.236 417.963Z",
    fill: "#C8F7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.97 476.966C149.233 478.785 149.497 480.42 149.497 482.239",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.895 435.835C141.829 445.163 146.475 458.156 148.442 471.693",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.918 431.089C133.029 425.019 131.041 421.449 131.041 421.449C131.041 421.449 136.098 419.129 138.444 414.668C140.791 410.207 144.224 407.886 144.224 407.886",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.002 441.108C111.002 441.108 131.041 432.876 131.041 434.453",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.642 430.034C142.642 430.034 151.801 425.815 160.043 425.815",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.478 443.744C139.478 443.744 134.368 447.757 128.525 454.686C122.682 461.616 120.494 468.001 120.494 468.001",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.806 446.281C145.806 446.281 157.523 443.048 163.735 448.49",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.099 368.652C160.919 365.022 154.011 364.84 150.557 361.029C147.103 357.217 153.826 355.221 157.28 356.672C160.919 358.125 169.098 362.299 170.553 363.388C172.188 364.295 171.096 350.865 168.191 345.783C165.28 340.7 157.465 337.796 153.463 341.971C145.104 350.683 132.195 339.249 133.102 332.351C134.015 325.454 127.65 318.194 113.834 322.369C100.203 326.725 105.291 329.084 105.291 329.084C105.291 329.084 115.11 335.074 121.29 338.704C127.471 342.334 137.833 345.601 135.649 348.323C133.466 351.046 127.471 349.412 122.382 345.419C117.473 341.426 103.108 331.807 101.658 335.437C100.203 339.067 95.1139 348.687 95.1139 348.687C95.1139 348.687 105.476 350.32 113.834 352.861C122.197 355.402 123.832 360.121 117.288 360.484C110.744 360.847 98.9317 355.946 95.2932 362.118C91.6599 368.288 94.2016 384.441 94.2016 384.441C94.2016 384.441 106.198 376.275 112.199 376.456C118.2 376.638 114.382 379.906 107.654 384.262C100.93 388.618 99.111 390.253 99.111 390.253L105.291 406.041C105.291 406.041 115.474 404.77 119.65 404.954L123.653 405.313C123.653 405.313 123.653 388.618 128.378 383.714C133.287 378.815 134.015 390.253 135.106 393.153C136.198 396.058 133.102 404.77 133.102 404.77C133.102 404.77 144.92 398.236 148.738 395.695L152.556 393.153C152.556 393.153 148.195 380.993 145.104 377.545C142.194 374.096 138.012 374.641 141.466 371.556C144.92 368.47 150.009 370.103 153.104 374.46C156.009 378.815 159.464 387.162 159.464 387.162C159.464 387.162 163.824 387.89 169.646 381.357C175.278 374.641 173.279 372.463 167.099 368.652ZM112.927 386.983C108.381 384.626 119.292 380.086 119.292 380.086C123.289 379.543 117.473 389.34 112.927 386.983ZM120.563 365.748C118.564 364.84 124.56 362.844 124.56 362.844C132.923 364.296 122.561 366.655 120.563 365.748Z",
    fill: "#C8F7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.112 398.922C111.82 400.214 110.712 401.506 109.42 402.613",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.314 363.064C132.016 372.208 125.393 384.278 116.803 394.703",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.423 358.845C141.165 352.442 142.626 348.298 142.626 348.298C142.626 348.298 147.741 350.747 152.671 349.428C157.607 348.11 161.625 349.24 161.625 349.24",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.221 346.189C115.221 346.189 134.869 356.174 133.619 357.263",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.223 363.064C144.223 363.064 153.705 367.071 158.988 373.083",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.568 369.478C131.568 369.478 125.198 368.168 116.276 368.355C107.353 368.542 100.983 370.974 100.983 370.974",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.204 375.719C134.204 375.719 144.398 382.554 144.224 391.012",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1131 447.873C73.0349 444.978 67.5982 444.794 64.8772 441.714C62.1562 438.64 67.4136 437.005 70.3139 438.276C73.2142 439.362 79.7425 442.8 81.0134 443.528C82.2842 444.251 81.3772 433.388 79.02 429.401C76.6629 425.415 70.3139 422.883 67.2343 426.322C60.5267 433.388 50.1911 424.149 50.7343 418.718C51.4567 413.281 46.3838 407.306 35.3206 410.744C24.2625 414.188 28.4337 416.181 28.4337 416.181C28.4337 416.181 36.2275 420.89 41.3057 423.97C46.3838 426.865 54.5416 429.401 52.9069 431.574C51.0981 433.746 46.3839 432.481 42.392 429.222C38.4054 425.958 26.799 418.354 25.7127 421.249C24.4418 424.149 20.4553 431.938 20.4553 431.938C20.4553 431.938 28.7975 433.203 35.5051 435.196C42.2127 437.369 43.4835 440.992 38.4054 441.356C33.148 441.714 23.7194 437.733 20.6345 442.621C17.555 447.51 19.7276 460.55 19.7276 460.55C19.7276 460.55 29.3407 454.033 34.2343 454.033C39.1279 454.033 36.0483 456.748 30.6063 460.371C25.1696 463.809 23.7194 465.08 23.7194 465.08L28.613 477.757C28.613 477.757 36.7707 476.671 40.0349 476.85L43.299 477.035C43.299 477.035 43.299 463.63 47.1063 459.649C50.9136 455.662 51.6413 464.901 52.3638 467.253C53.2708 469.61 50.7343 476.671 50.7343 476.671C50.7343 476.671 60.1629 471.418 63.2425 469.425L66.3273 467.432C66.3273 467.432 62.6994 457.655 60.3422 454.94C57.9851 452.219 54.7209 452.582 57.4419 450.231C60.1629 447.873 64.334 449.144 66.6912 452.582C69.0483 456.026 71.764 462.723 71.764 462.723C71.764 462.723 75.392 463.266 79.927 458.014C84.6413 452.582 83.1912 450.774 78.1131 447.873ZM34.5981 462.544C30.9701 460.735 39.6763 457.112 39.6763 457.112C42.9351 456.569 38.4054 464.358 34.5981 462.544ZM40.7626 445.337C39.1279 444.615 43.8422 442.985 43.8422 442.985C50.7343 444.435 42.392 446.244 40.7626 445.337Z",
    fill: "#C8F7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0671 472.22C34.081 473.406 32.8945 474.398 31.9032 475.384",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0511 443.744C50.5971 451.211 45.1393 460.682 38.2313 469.056",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6327 440.053C57.7842 434.991 58.86 431.616 58.86 431.616C58.86 431.616 62.9784 433.678 66.9228 432.555C70.8619 431.426 74.0891 432.365 74.0891 432.365",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.649 430.034C36.649 430.034 52.4266 438.086 51.3614 438.998",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8513 443.744C59.8513 443.744 67.6873 446.803 71.9797 451.654",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8323 448.933C49.8323 448.933 44.8016 447.794 37.6141 447.984C30.4266 448.174 25.5753 450.072 25.5753 450.072",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4145 453.764C51.4145 453.764 59.8517 459.116 59.8517 465.892",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.664 509.57C121.596 506.675 116.16 506.491 113.444 503.411C110.728 500.337 115.98 498.702 118.881 499.973C121.776 501.239 128.299 504.498 129.564 505.225C130.83 505.948 129.928 495.085 127.571 491.098C125.219 487.112 118.881 484.581 115.801 488.019C109.099 495.085 98.7737 485.846 99.3168 480.415C99.86 474.978 94.9717 469.003 83.9242 472.442C72.8767 475.885 77.0426 477.878 77.0426 477.878C77.0426 477.878 84.8259 482.587 89.8988 485.667C94.9716 488.562 103.119 491.098 101.31 493.271C99.4961 495.443 94.7871 494.178 90.8058 490.919C86.8192 487.655 75.2286 480.051 74.1423 482.946C72.8767 485.846 68.8901 493.635 68.8901 493.635C68.8901 493.635 77.2219 494.9 83.9242 496.894C90.6265 498.887 91.8921 502.689 86.8192 503.053C81.567 503.411 72.149 499.43 69.0694 504.318C66.1744 509.391 68.1677 522.247 68.1677 522.247C68.1677 522.247 77.765 515.73 82.6533 515.73C87.5469 515.73 84.4673 518.445 79.0306 522.068C73.5991 525.691 72.149 526.777 72.149 526.777L77.0426 539.454C77.0426 539.454 85.1898 538.368 88.4486 538.547L91.7128 538.732C91.7128 538.732 91.7128 525.327 95.5148 521.346C99.3168 517.359 100.045 526.598 100.767 528.95C101.674 531.302 99.1375 538.368 99.1375 538.368C99.1375 538.368 108.556 533.116 111.635 531.122L114.715 529.129C114.715 529.129 111.092 519.352 108.735 516.637C106.383 513.916 103.119 514.28 105.84 511.928C108.556 509.571 112.721 510.841 115.073 514.28C117.43 517.723 120.146 524.42 120.146 524.42C120.146 524.42 123.769 524.963 128.299 519.711C133.187 514.28 131.737 512.471 126.664 509.57ZM83.1965 524.241C79.5738 522.432 88.2694 518.809 88.2694 518.809C91.5282 518.266 87.0038 526.055 83.1965 524.241ZM89.535 507.034C87.9055 506.312 92.6145 504.682 92.6145 504.682C99.3168 505.948 90.9851 507.941 89.535 507.034Z",
    fill: "#C8F7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5812 533.917C82.5951 535.104 81.4086 536.095 80.4172 537.081",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.038 505.442C98.5836 512.908 93.1258 522.374 86.2178 530.753",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 501.75C105.829 496.688 106.936 493.313 106.936 493.313C106.936 493.313 111.176 495.375 115.231 494.252C119.286 493.123 122.603 494.062 122.603 494.062",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6355 491.731C84.6355 491.731 100.977 499.783 99.8752 500.696",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.366 505.442C108.366 505.442 115.864 508.5 119.967 513.351",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3463 510.63C98.3463 510.63 93.2049 509.491 85.8645 509.681C78.5188 509.871 73.562 511.769 73.562 511.769",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.456 515.461C100.456 515.461 108.366 521.045 108.366 528.117",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9217 353.224C57.9217 353.224 51.5568 357.792 47.5597 353.224C43.5626 348.655 49.1944 339.335 43.5626 335.863C37.9255 332.391 28.6551 338.97 28.6551 338.97C28.6551 338.97 36.1062 340.615 36.1062 344.818C36.1062 349.021 32.6522 350.666 32.1091 348.838C31.5607 347.193 27.5635 338.422 21.7471 342.442C15.9307 346.462 15.3876 352.31 15.3876 352.31C15.3876 352.31 29.1982 349.935 30.2898 355.234C31.3813 360.351 24.4734 354.686 18.8363 354.686C13.0199 354.686 7.93117 355.782 8.47959 359.255C9.02273 362.727 8.47959 368.575 8.47959 368.575C8.47959 368.575 13.0199 364.006 19.3847 364.006C25.7443 364.006 25.7443 368.026 19.9279 368.026C14.1115 368.026 9.56591 373.874 9.56591 373.874C9.56591 373.874 15.3876 382.464 22.111 386.667C29.019 390.685 31.2021 389.04 31.9245 385.57C32.473 382.1 30.2898 373.508 34.2922 373.508C38.2894 373.508 28.4705 389.04 33.7438 389.588C38.8325 390.136 42.8349 388.491 44.1058 385.021L45.1973 381.552C45.1973 381.552 42.8349 372.96 43.5626 369.488C44.1057 366.016 45.1973 369.488 46.4682 373.508C47.5597 377.529 48.8306 387.4 50.4706 386.851C52.1053 386.303 57.3733 378.809 58.4648 375.884C59.5564 372.96 50.4706 364.92 50.4706 363.275C50.4706 361.447 57.3733 364.371 58.4648 366.199C59.5564 367.844 60.8272 370.219 60.8272 370.219C60.8272 370.219 64.8297 367.295 64.2813 359.255C63.5535 350.483 57.9217 353.407 57.9217 353.224Z",
    fill: "#C8F7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1029 374.665C30.0631 369.162 35.8267 361.459 40.868 357.79",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3568 380.993C21.3568 380.993 22.6223 379.485 24.5207 377.301",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0319 358.845C44.0319 358.845 50.8555 367.444 52.4691 376.774",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1764 364.673C37.1764 364.673 38.7584 363.621 38.7584 374.665",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8678 353.572C40.8678 353.572 44.6698 350.047 42.0701 343.553",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6494 359.372L33.4855 354.626",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3758 364.646C31.3758 364.646 22.8964 358.845 17.6653 358.845",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.748 680.514H71.4526L76.8999 555.538H110.121L115.748 680.514Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 3.62536,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.268 133.15V114.693H197.484V133.15H222.268Z",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.068 82.5262H195.902V573.994H585.068V82.5262Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.602 500.168H274.473V543.936H286.602V500.168Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.222 491.204H295.566V543.936H308.222V491.204Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.842 481.185H317.186V543.936H329.842V481.185Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.935 474.857H338.807V543.936H350.935V474.857Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.556 495.423H360.427V543.936H372.556V495.423Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.176 460.091H381.52V543.936H394.176V460.091Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.796 476.966H403.141V543.936H415.796V476.966Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.89 474.857H424.761V543.936H436.89V474.857Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.51 462.201H445.854V543.936H458.51V462.201Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.946 465.365H467.475V543.936H480.13V465.365H479.946Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.751 461.673H489.095V543.936H501.751V461.673Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.843 458.51H510.715V543.936H522.843V458.51Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.464 490.149H531.808V543.936H544.464V490.149Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.326 543.936H233.869",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.326 522.843H233.869",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.326 501.223H233.869",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.326 480.13H233.869",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.326 458.51H233.869",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.548 248.806V222.268H559.756V318.241H534.197",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.677 245.47H544.464",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.677 256.544H544.464",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.677 267.618H544.464",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.824 278.692H544.464",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.677 278.692H506.497",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.677 289.238H544.464",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.281 300.312H544.464",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.677 300.312H523.371",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.021 133.207C334.298 133.575 332.853 133.94 330.865 133.94C325.086 133.94 322.196 130.277 322.196 125.514C322.196 119.836 326.167 116.539 331.224 116.539C333.212 116.539 334.657 116.905 335.379 117.271L334.657 120.202C333.935 119.836 332.854 119.653 331.588 119.653C328.698 119.653 326.352 121.485 326.352 125.148C326.352 128.445 328.334 130.643 331.588 130.643C332.669 130.643 333.935 130.46 334.657 130.094L335.021 133.207Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.726 125.148C351.726 130.643 348.489 133.94 343.637 133.94C338.78 133.94 335.907 130.094 335.907 125.331C335.907 120.569 339.144 116.539 343.996 116.539C348.668 116.722 351.726 120.569 351.726 125.148ZM339.861 125.331C339.861 128.628 341.48 131.01 343.816 131.01C346.152 131.01 347.771 128.628 347.771 125.331C347.771 122.217 346.332 119.653 343.816 119.653C341.301 119.653 339.861 122.034 339.861 125.331Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.836 133.581V117.066H358.223L361.698 123.169C362.795 124.965 363.707 126.94 364.44 128.914C364.255 126.76 364.071 124.426 364.071 122.093V117.246H367.546V133.761H363.522L359.868 127.478C358.956 125.683 357.859 123.528 356.941 121.733C357.126 123.888 357.126 126.222 357.126 128.914V133.94H353.836V133.581Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.112 120.218H369.656V117.066H382.311V120.218H377.856V133.94H374.112V120.218Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.171 129.538L385.08 133.94H381.256L386.356 117.066H391.27L396.549 133.94H392.541L391.27 129.538H386.171ZM390.358 126.787L389.267 123.302C388.903 122.385 388.723 121.101 388.354 120.001C388.175 120.918 387.811 122.202 387.627 123.302L386.535 126.787H390.358Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.404 117.425C404.812 117.245 406.568 117.066 408.324 117.066C411.314 117.066 413.423 117.604 415.005 118.861C416.761 120.118 417.642 122.093 417.642 125.144C417.642 128.376 416.587 130.53 415.005 131.786C413.249 133.222 410.787 133.94 407.623 133.94C405.687 133.94 404.459 133.761 403.404 133.761V117.425ZM407.095 130.889C407.449 130.889 407.976 130.889 408.324 130.889C411.667 130.889 413.776 129.094 413.776 125.144C413.776 121.733 411.841 119.938 408.677 119.938C407.797 119.938 407.269 119.938 407.095 120.118V130.889Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.918 126.787H423.917V130.822H430.825V133.94H420.279V117.066H430.646V120.184H423.917V123.669H430.098V126.787H429.918Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.208 117.066H441.899V130.359H448.227V133.413H438.208V117.066Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.464 117.066V126.581C453.464 129.453 454.56 130.889 456.575 130.889C458.584 130.889 459.681 129.453 459.681 126.581V117.066H463.52V126.401C463.52 131.427 460.962 133.94 456.575 133.94C452.187 133.94 449.809 131.607 449.809 126.401V117.246L453.464 117.066Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.101 131.923L473.27 120.368V120.184H465.845V117.066H478.285V119.267L470.301 130.639V130.822H478.285V133.94H465.101V131.923Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.43 450.6H415.797",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.695 450.6H373.083",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.358 248.806V222.268H466.42V318.241H386.888",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.556 318.241H214.358V262.872",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.249 354.888V328.787H559.757V423.179H450.11",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.034 423.706H211.722V369.391",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.741 351.99H399.977",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.741 363.064H399.977",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67 385.211H344.608",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.962 406.832H298.73",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.741 406.832H329.842",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.924 397.34H444.799",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.869 204.075H206.712V432.934H508.869V204.075Z",
    fill: "white",
    fillOpacity: 0.901961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.493 253.293V205.393H495.95V378.356H429.349",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.851 378.356H284.493V286.074",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75 247.579H416.852",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75 273.946H416.852",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75 300.312H416.852",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.045 326.678H416.324",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75 326.678H339.862",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75 353.044H416.852",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.303 244.223H311.762V232.457H307.542V231.091H317.522V232.457H313.303V244.223ZM319.938 232.702C319.693 232.702 319.486 232.617 319.317 232.448C319.153 232.273 319.072 232.063 319.072 231.818C319.072 231.578 319.153 231.374 319.317 231.205C319.486 231.036 319.693 230.951 319.938 230.951C320.189 230.951 320.4 231.036 320.569 231.205C320.738 231.374 320.823 231.578 320.823 231.818C320.823 232.063 320.738 232.273 320.569 232.448C320.4 232.617 320.189 232.702 319.938 232.702ZM320.656 244.223H319.221V235.468H320.656V244.223ZM328.5 244.013C327.923 244.269 327.359 244.398 326.811 244.398C326.285 244.398 325.824 244.284 325.427 244.056C325.031 243.823 324.721 243.499 324.5 243.085C324.278 242.664 324.167 242.177 324.167 241.623V236.755H322.635V235.468H324.237V233.28H325.603V235.468H328.22V236.755H325.603V241.36C325.603 241.885 325.743 242.308 326.023 242.629C326.309 242.95 326.682 243.111 327.143 243.111C327.517 243.111 327.89 243 328.264 242.778L328.5 244.013ZM338.445 244.223H337.185L337.132 242.804C336.811 243.318 336.388 243.712 335.863 243.986C335.343 244.261 334.728 244.398 334.016 244.398C332.854 244.398 331.935 244.048 331.258 243.347C330.587 242.641 330.251 241.678 330.251 240.458V235.468H331.687V240.353C331.687 241.182 331.92 241.844 332.387 242.34C332.86 242.837 333.487 243.085 334.269 243.085C335.087 243.085 335.746 242.816 336.248 242.279C336.756 241.742 337.01 241.042 337.01 240.178V235.468H338.445V244.223ZM342.682 244.223H341.159V231.091H342.682V244.223ZM352.461 244.223H351.227L351.131 243.067C350.81 243.481 350.401 243.808 349.905 244.048C349.409 244.281 348.854 244.398 348.242 244.398C347.611 244.398 347.048 244.275 346.552 244.03C346.056 243.779 345.665 243.438 345.379 243.006C345.099 242.574 344.959 242.084 344.959 241.535C344.959 240.957 345.11 240.449 345.414 240.012C345.723 239.568 346.14 239.221 346.666 238.97C347.197 238.719 347.798 238.594 348.469 238.594C348.907 238.594 349.353 238.649 349.809 238.76C350.264 238.865 350.669 239.011 351.025 239.198V238.83C351.025 238.363 350.909 237.966 350.675 237.639C350.442 237.307 350.13 237.053 349.739 236.878C349.348 236.697 348.916 236.606 348.443 236.606C348.034 236.606 347.617 236.682 347.191 236.834C346.765 236.98 346.356 237.207 345.965 237.517L345.493 236.282C346 235.956 346.534 235.71 347.095 235.547C347.655 235.378 348.209 235.293 348.758 235.293C349.517 235.293 350.17 235.448 350.719 235.757C351.273 236.061 351.702 236.495 352.006 237.062C352.309 237.622 352.461 238.287 352.461 239.058V244.223ZM348.495 243.085C348.945 243.085 349.356 242.991 349.73 242.804C350.103 242.618 350.407 242.349 350.64 241.999C350.874 241.643 351.002 241.223 351.025 240.738V240.59C350.704 240.339 350.343 240.146 349.94 240.012C349.543 239.872 349.137 239.802 348.723 239.802C348.075 239.802 347.532 239.959 347.095 240.274C346.663 240.59 346.447 240.989 346.447 241.474C346.447 241.777 346.534 242.052 346.71 242.297C346.89 242.542 347.136 242.734 347.445 242.874C347.754 243.015 348.104 243.085 348.495 243.085ZM356.444 244.223H355.009V235.468H356.269L356.331 237.202C356.634 236.6 357.06 236.134 357.609 235.801C358.163 235.462 358.799 235.293 359.517 235.293C359.675 235.293 359.835 235.302 359.999 235.319C360.162 235.337 360.326 235.363 360.489 235.398L360.314 236.694C359.993 236.618 359.675 236.58 359.36 236.58C358.788 236.58 358.28 236.72 357.836 237C357.399 237.28 357.057 237.666 356.812 238.156C356.567 238.646 356.444 239.209 356.444 239.845V244.223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.366 267.853C318.765 268.46 318.047 268.936 317.213 269.28C316.378 269.625 315.468 269.797 314.481 269.797C313.495 269.797 312.585 269.628 311.75 269.289C310.921 268.951 310.201 268.475 309.588 267.862C308.975 267.244 308.499 266.52 308.161 265.691C307.822 264.856 307.653 263.949 307.653 262.968C307.653 261.982 307.822 261.075 308.161 260.246C308.499 259.411 308.975 258.688 309.588 258.075C310.201 257.462 310.921 256.986 311.75 256.648C312.585 256.309 313.495 256.14 314.481 256.14C315.462 256.14 316.369 256.312 317.204 256.656C318.039 256.995 318.757 257.468 319.358 258.075L318.281 259.169C317.814 258.65 317.254 258.244 316.6 257.952C315.946 257.654 315.231 257.506 314.455 257.506C313.702 257.506 313.008 257.643 312.372 257.917C311.735 258.186 311.181 258.568 310.708 259.064C310.241 259.554 309.877 260.132 309.614 260.797C309.357 261.463 309.229 262.186 309.229 262.968C309.229 263.756 309.357 264.483 309.614 265.148C309.877 265.808 310.241 266.386 310.708 266.882C311.181 267.372 311.735 267.754 312.372 268.028C313.008 268.297 313.702 268.431 314.455 268.431C315.231 268.431 315.946 268.285 316.6 267.993C317.254 267.696 317.814 267.287 318.281 266.768L319.366 267.853ZM321.555 269.534V256.403H325.6C326.673 256.403 327.593 256.569 328.357 256.902C329.128 257.234 329.717 257.71 330.126 258.329C330.534 258.947 330.738 259.688 330.738 260.552C330.738 261.41 330.534 262.151 330.126 262.776C329.717 263.4 329.128 263.882 328.357 264.22C327.593 264.553 326.673 264.719 325.6 264.719H323.096V269.534H321.555ZM323.096 263.354H325.468C326.647 263.354 327.558 263.106 328.2 262.61C328.842 262.113 329.163 261.428 329.163 260.552C329.163 259.677 328.842 258.994 328.2 258.504C327.558 258.013 326.647 257.768 325.468 257.768H323.096V263.354ZM332.848 269.534V256.403H340.762V257.768H334.389V262.181H340.403V263.546H334.389V269.534H332.848ZM343.546 269.709H342.163L347.748 256.228H349.123L343.546 269.709ZM361.72 267.853C361.119 268.46 360.401 268.936 359.567 269.28C358.732 269.625 357.822 269.797 356.835 269.797C355.849 269.797 354.939 269.628 354.104 269.289C353.275 268.951 352.554 268.475 351.942 267.862C351.329 267.244 350.853 266.52 350.515 265.691C350.176 264.856 350.007 263.949 350.007 262.968C350.007 261.982 350.176 261.075 350.515 260.246C350.853 259.411 351.329 258.688 351.942 258.075C352.554 257.462 353.275 256.986 354.104 256.648C354.939 256.309 355.849 256.14 356.835 256.14C357.816 256.14 358.723 256.312 359.558 256.656C360.393 256.995 361.11 257.468 361.712 258.075L360.635 259.169C360.168 258.65 359.608 258.244 358.954 257.952C358.3 257.654 357.585 257.506 356.809 257.506C356.056 257.506 355.362 257.643 354.726 257.917C354.089 258.186 353.535 258.568 353.062 259.064C352.595 259.554 352.231 260.132 351.968 260.797C351.711 261.463 351.583 262.186 351.583 262.968C351.583 263.756 351.711 264.483 351.968 265.148C352.231 265.808 352.595 266.386 353.062 266.882C353.535 267.372 354.089 267.754 354.726 268.028C355.362 268.297 356.056 268.431 356.809 268.431C357.585 268.431 358.3 268.285 358.954 267.993C359.608 267.696 360.168 267.287 360.635 266.768L361.72 267.853ZM375.334 269.534H373.705L365.45 258.81V269.534H363.909V256.403H365.537L373.793 267.127V256.403H375.334V269.534ZM378.056 269.534V256.403H382.101C383.175 256.403 384.094 256.569 384.858 256.902C385.629 257.234 386.218 257.71 386.627 258.329C387.035 258.947 387.24 259.688 387.24 260.552C387.24 261.41 387.035 262.151 386.627 262.776C386.218 263.4 385.629 263.882 384.858 264.22C384.094 264.553 383.175 264.719 382.101 264.719H379.597V269.534H378.056ZM379.597 263.354H381.969C383.148 263.354 384.059 263.106 384.701 262.61C385.343 262.113 385.664 261.428 385.664 260.552C385.664 259.677 385.343 258.994 384.701 258.504C384.059 258.013 383.148 257.768 381.969 257.768H379.597V263.354ZM386.355 272.686L386.285 271.329C387.342 271.329 388.133 271.069 388.658 270.55C389.183 270.036 389.446 269.269 389.446 268.247V256.403H390.986V268.177C390.986 269.222 390.823 270.077 390.496 270.742C390.175 271.408 389.673 271.898 388.99 272.213C388.313 272.528 387.435 272.686 386.355 272.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.593 296.955V283.824H316.638V285.189H310.133V289.601H316.279V290.967H310.133V295.589H316.726V296.955H308.593ZM327.555 296.955H326.119V291.904C326.119 291.116 325.897 290.491 325.454 290.03C325.016 289.569 324.418 289.339 323.659 289.339C323.116 289.339 322.629 289.461 322.197 289.707C321.765 289.946 321.424 290.284 321.173 290.722C320.922 291.16 320.796 291.667 320.796 292.245V296.955H319.361V288.201H320.613L320.665 289.619C320.986 289.105 321.43 288.711 321.996 288.437C322.568 288.163 323.21 288.026 323.922 288.026C325.036 288.026 325.921 288.361 326.574 289.032C327.228 289.704 327.555 290.608 327.555 291.746V296.955ZM338.638 296.955H337.36L337.281 295.677C336.878 296.126 336.388 296.482 335.81 296.745C335.232 297.002 334.599 297.13 333.911 297.13C333.053 297.13 332.282 296.932 331.599 296.535C330.917 296.138 330.377 295.595 329.98 294.907C329.589 294.218 329.393 293.442 329.393 292.578C329.393 291.708 329.589 290.932 329.98 290.249C330.377 289.561 330.917 289.018 331.599 288.621C332.282 288.224 333.053 288.026 333.911 288.026C334.576 288.026 335.189 288.145 335.749 288.385C336.315 288.624 336.799 288.957 337.202 289.383V283.824H338.638V296.955ZM334.042 295.835C334.625 295.835 335.157 295.7 335.635 295.432C336.114 295.158 336.493 294.787 336.773 294.32C337.059 293.847 337.202 293.313 337.202 292.718V292.42C337.202 291.825 337.059 291.294 336.773 290.827C336.493 290.354 336.114 289.984 335.635 289.715C335.157 289.447 334.625 289.313 334.042 289.313C333.435 289.313 332.892 289.456 332.414 289.742C331.935 290.028 331.556 290.416 331.275 290.906C331.001 291.396 330.864 291.951 330.864 292.569C330.864 293.188 331.001 293.745 331.275 294.241C331.556 294.732 331.935 295.12 332.414 295.406C332.892 295.692 333.435 295.835 334.042 295.835ZM349.029 295.878C347.944 296.713 346.747 297.13 345.44 297.13C344.53 297.13 343.713 296.926 342.989 296.517C342.265 296.109 341.693 295.554 341.273 294.854C340.859 294.148 340.651 293.351 340.651 292.464C340.651 291.612 340.844 290.853 341.229 290.188C341.614 289.517 342.143 288.989 342.814 288.603C343.485 288.218 344.247 288.026 345.099 288.026C345.974 288.026 346.745 288.236 347.41 288.656C348.081 289.076 348.603 289.66 348.977 290.407C349.35 291.154 349.537 292.018 349.537 292.998V293.278H342.21C342.315 293.792 342.525 294.238 342.84 294.618C343.155 294.997 343.549 295.292 344.022 295.502C344.5 295.712 345.032 295.817 345.615 295.817C346.619 295.817 347.535 295.487 348.364 294.828L349.029 295.878ZM342.157 292.053H348.18C348.116 291.51 347.947 291.037 347.673 290.634C347.404 290.226 347.054 289.908 346.622 289.68C346.196 289.453 345.714 289.339 345.177 289.339C344.635 289.339 344.144 289.453 343.707 289.68C343.275 289.908 342.922 290.226 342.647 290.634C342.379 291.037 342.216 291.51 342.157 292.053ZM352.995 296.955H351.559V288.201H352.82L352.881 289.934C353.185 289.333 353.611 288.866 354.16 288.533C354.714 288.195 355.35 288.026 356.068 288.026C356.226 288.026 356.386 288.034 356.55 288.052C356.713 288.069 356.876 288.096 357.04 288.131L356.865 289.426C356.544 289.35 356.226 289.313 355.91 289.313C355.338 289.313 354.831 289.453 354.387 289.733C353.949 290.013 353.608 290.398 353.363 290.888C353.118 291.379 352.995 291.942 352.995 292.578V296.955ZM366.206 295.878C365.12 296.713 363.924 297.13 362.616 297.13C361.706 297.13 360.889 296.926 360.165 296.517C359.441 296.109 358.869 295.554 358.449 294.854C358.035 294.148 357.828 293.351 357.828 292.464C357.828 291.612 358.02 290.853 358.405 290.188C358.791 289.517 359.319 288.989 359.99 288.603C360.661 288.218 361.423 288.026 362.275 288.026C363.15 288.026 363.921 288.236 364.586 288.656C365.257 289.076 365.78 289.66 366.153 290.407C366.527 291.154 366.713 292.018 366.713 292.998V293.278H359.386C359.491 293.792 359.701 294.238 360.016 294.618C360.331 294.997 360.725 295.292 361.198 295.502C361.677 295.712 362.208 295.817 362.791 295.817C363.795 295.817 364.712 295.487 365.54 294.828L366.206 295.878ZM359.333 292.053H365.356C365.292 291.51 365.123 291.037 364.849 290.634C364.58 290.226 364.23 289.908 363.798 289.68C363.372 289.453 362.891 289.339 362.354 289.339C361.811 289.339 361.321 289.453 360.883 289.68C360.451 289.908 360.098 290.226 359.824 290.634C359.555 291.037 359.392 291.51 359.333 292.053ZM376.011 295.695C375.585 296.156 375.08 296.512 374.496 296.763C373.912 297.008 373.285 297.13 372.614 297.13C371.744 297.13 370.962 296.932 370.268 296.535C369.579 296.138 369.033 295.595 368.631 294.907C368.234 294.218 368.035 293.442 368.035 292.578C368.035 291.708 368.234 290.932 368.631 290.249C369.033 289.561 369.579 289.018 370.268 288.621C370.962 288.224 371.744 288.026 372.614 288.026C373.279 288.026 373.904 288.148 374.487 288.393C375.071 288.638 375.576 288.992 376.002 289.453L375.144 290.354C374.835 290.028 374.464 289.777 374.032 289.601C373.606 289.426 373.154 289.339 372.675 289.339C372.062 289.339 371.517 289.479 371.038 289.759C370.565 290.033 370.192 290.413 369.918 290.897C369.649 291.382 369.515 291.939 369.515 292.569C369.515 293.2 369.649 293.76 369.918 294.25C370.192 294.74 370.565 295.126 371.038 295.406C371.517 295.68 372.062 295.817 372.675 295.817C373.154 295.817 373.609 295.73 374.041 295.554C374.473 295.374 374.84 295.123 375.144 294.802L376.011 295.695ZM371.091 300.378L371.388 299.643C371.651 299.754 371.919 299.809 372.194 299.809C372.521 299.809 372.792 299.73 373.008 299.573C373.224 299.421 373.332 299.228 373.332 298.995C373.332 298.744 373.209 298.537 372.964 298.373C372.719 298.21 372.415 298.128 372.054 298.128C372.024 298.128 371.992 298.128 371.957 298.128C371.928 298.128 371.899 298.131 371.87 298.137L372.351 296.894H373.052L372.745 297.629C373.177 297.67 373.524 297.813 373.787 298.058C374.05 298.309 374.181 298.63 374.181 299.021C374.181 299.476 374.003 299.85 373.647 300.142C373.291 300.439 372.827 300.588 372.255 300.588C371.876 300.588 371.487 300.518 371.091 300.378ZM381.92 297.13C381.05 297.13 380.268 296.932 379.574 296.535C378.879 296.138 378.331 295.598 377.928 294.915C377.531 294.227 377.333 293.448 377.333 292.578C377.333 291.714 377.531 290.941 377.928 290.258C378.331 289.569 378.879 289.027 379.574 288.63C380.268 288.227 381.05 288.026 381.92 288.026C382.789 288.026 383.569 288.227 384.257 288.63C384.946 289.027 385.489 289.569 385.886 290.258C386.282 290.941 386.481 291.714 386.481 292.578C386.481 293.448 386.282 294.227 385.886 294.915C385.489 295.598 384.946 296.138 384.257 296.535C383.569 296.932 382.789 297.13 381.92 297.13ZM381.911 295.835C382.501 295.835 383.029 295.692 383.496 295.406C383.963 295.12 384.33 294.732 384.599 294.241C384.873 293.751 385.01 293.197 385.01 292.578C385.01 291.959 384.873 291.405 384.599 290.915C384.33 290.424 383.963 290.036 383.496 289.75C383.029 289.464 382.501 289.321 381.911 289.321C381.322 289.321 380.791 289.464 380.318 289.75C379.851 290.036 379.48 290.424 379.206 290.915C378.938 291.405 378.803 291.959 378.803 292.578C378.803 293.197 378.938 293.751 379.206 294.241C379.48 294.732 379.851 295.12 380.318 295.406C380.791 295.692 381.322 295.835 381.911 295.835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.414 153.133C325.724 135.19 246.762 185.394 229.013 265.323C211.263 345.252 261.248 424.276 340.753 442.215C420.442 460.16 499.404 409.959 517.154 330.028C534.904 250.28 484.919 171.076 405.414 153.133ZM346.19 417.932C279.905 403.067 238.246 337.096 253.101 270.579C267.95 204.063 333.692 162.377 399.977 177.238C466.262 192.1 507.921 258.074 493.066 324.59C478.216 391.107 412.475 432.977 346.19 417.932Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.81268,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.656 617.92C661.942 616.834 657.227 614.482 653.42 610.854L477.736 446.313C466.314 435.624 465.771 417.499 476.465 406.088C487.165 394.671 505.115 393.944 516.716 404.817L692.4 569.359C703.822 580.048 704.365 598.172 693.671 609.588C686.415 617.198 676.084 619.914 666.656 617.92Z",
    fill: "#22420D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_91_1768)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.001,
    y: 104,
    width: 50.0001,
    height: 50.0001,
    rx: 17.5758,
    fill: "#22420D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.501 141V138H237.501V141C237.501 142.65 238.851 144 240.501 144H243.501C245.151 144 246.501 142.65 246.501 141ZM236.286 133.62C236.481 133.89 236.721 134.415 236.931 135H247.071C247.296 134.415 247.521 133.89 247.716 133.62C248.241 132.87 248.796 132.225 249.336 131.58C250.881 129.765 252.486 127.89 252.486 124.5C252.486 118.71 247.776 114 241.986 114C236.196 114 231.486 118.71 231.486 124.5C231.486 127.92 233.091 129.795 234.636 131.595C235.176 132.225 235.731 132.87 236.271 133.62H236.286ZM242.001 118.5V121.5C240.351 121.5 239.001 122.85 239.001 124.5H236.001C236.001 121.185 238.686 118.5 242.001 118.5Z",
    fill: "#97EC5F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_91_1768",
    x: 213.382,
    y: 103.276,
    width: 57.2373,
    height: 57.2373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.44744
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.723718
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_1768"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.723718,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_91_1768"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.89487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44744
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_91_1768",
    result: "effect2_dropShadow_91_1768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_91_1768",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolder);
export default __webpack_public_path__ + "static/media/holder.626cf3eeae59d28c9380d1c52e33e2c2.svg";
export { ForwardRef as ReactComponent };